import { openMailTo } from "../../../external_link";
import { Agency } from "../../../system/AppState/AppAgenciesState";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { getMedFlytLog } from "../../../utils/DeviceUtils";

export default function sendRecruitEmail(
  caregiver: AppCaregiver,
  agencies: Iterable<Agency>,
  epilogue?: string
) {
  const to = "info+agencyrequest@medflyt.com";

  const subject = `${caregiver.firstName} ${caregiver.lastName}, i don't have an agency yet"`;

  const message = `
    I downloaded this app to get cases but i don't have an agency.
    Can you please help me find one so i can start working?
    `;

  const body = `
        ${message}
        ${getMedFlytLog(caregiver, agencies, epilogue)}
    `;

  openMailTo(to, subject, body);
}
